import {useStyles} from '@webapps/styles';
import PropTypes from 'prop-types';

import theme from '../theme';

const {
  colors: {cellTitleTextColor},
} = theme;

const TableCellTitle = ({children}) => {
  const {classes} = useStyles(styles);
  return <div className={classes.tableCellTitle}>{children}</div>;
};

const styles = ({fontSizes}) => ({
  tableCellTitle: {
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    color: cellTitleTextColor,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
});

TableCellTitle.propTypes = {
  children: PropTypes.node,
};

export default TableCellTitle;
